<template>
    <div style="position: absolute;left: 28mm;top: 0px;">
        <div v-if="urgentLevel"
             style="font-family: 黑体;font-size: 16pt;width: 17mm;text-align-last: justify">
            {{urgentLevel}}
        </div>
        <div v-if="secretLevel"
             style="font-family: 黑体;font-size: 16pt;width: 17mm;text-align-last: justify">
            {{secretLevel}}
        </div>
    </div>
</template>

<script>
    export default {
        name: "DocSecret",
        props: {
            urgentLevel: {},
            secretLevel: {}
        }
    }
</script>